import { EnumHelper } from '@/mixins/enumHelper';

export const EnumUtils = {
  getEnumValues(enumType: any) {
    return (EnumHelper.methods.convertNumberBasedEnumToArray(
      enumType
    ) as Array<{
      key: number;
      value: string;
    }>).map((x) => ({ ...x, description: x.value.match(/[A-Z][a-z]*/g)?.join(' ') }));
  }
};